<template>
  <ValidationObserver ref="observer" class="modal-body" tag="div">
    <div class="form-group row">
      <ValidationProvider tag="div" name="price" rules="required" class="col-md-8">
        <div slot-scope="{ errors }">
          <label for="price" class="text-black">Cena za zboží</label>

          <input
            v-model="form.price"
            type="number"
            class="form-control"
            :class="{ 'is-invalid': errors[0] }"
            id="price"
            name="price"
            required
            @keyup="updateMap"
          />

          <span class="invalid-feedback" role="alert">
            <strong>{{ errors[0] }}</strong>
          </span>
        </div>
      </ValidationProvider>

      <div class="col-md-4">
        <ValidationProvider tag="div" name="bank_number" rules="required" class="mb-1">
          <div slot-scope="{ errors }">
            <label for="bank_number" class="text-black">Bankovní účet</label>

            <input
              v-model="form.bank_number"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors[0] }"
              id="bank_number"
              name="bank_number"
              required
              @keyup="updateMap"
            />

            <span class="invalid-feedback" role="alert">
              <strong>{{ errors[0] }}</strong>
            </span>
          </div>
        </ValidationProvider>

        <input type="checkbox" v-model="form.sync_bank_account" @change="updateMap"/>
        <span>Uložit do profilu</span>
      </div>
    </div>

    <template v-if="order.product.type !== 'service'">
      <div class="form-group row">
        <ValidationProvider tag="div" name="user_form_delivery_id" rules="required" class="col-md-8">
          <div slot-scope="{ errors }">
            <label for="user_form_delivery_id" class="text-black">Forma dopravy</label>

            <select
              v-model="form.user_form_delivery_id"
              class="form-control"
              :class="{ 'is-invalid': errors[0] }"
              name="user_form_delivery_id"
              @change="updateMap"
              required
            >
              <option v-for="delivery in formDeliveries" :value="delivery.id">
                {{ delivery.name }} - {{ delivery.price }} Kč
              </option>
            </select>

            <span class="invalid-feedback" role="alert">
              <strong>{{ errors[0] }}</strong>
            </span>
          </div>
        </ValidationProvider>

        <ValidationProvider tag="div" name="form_delivery_price" rules="required" class="col-md-4">
          <div slot-scope="{ errors }">
            <label for="form_delivery_price" class="text-black">Cena za dopravu</label>

            <input
              v-model="form.form_delivery_price"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': errors[0] }"
              id="form_delivery_price"
              name="form_delivery_price"
              required
              @keyup="updateMap"
            />
            <span class="invalid-feedback" role="alert">
              <strong>{{ errors[0] }}</strong>
            </span>
          </div>
        </ValidationProvider>
      </div>

      <div class="form-group row">
        <ValidationProvider tag="div" name="user_form_payment_id" rules="required" class="col-md-8">
          <div slot-scope="{ errors }">
            <label for="user_form_payment_id" class="text-black">Forma platby</label>

            <select
              v-model="form.user_form_payment_id"
              class="form-control"
              :class="{ 'is-invalid': errors[0] }"
              name="user_form_payment_id"
              @change="updateMap"
              required
            >
              <option v-for="payment in formPayments" :value="payment.id">
                {{ payment.name }} - {{ payment.price }} Kč
              </option>
            </select>

            <span class="invalid-feedback" role="alert">
              <strong>{{ errors[0] }}</strong>
            </span>
          </div>
        </ValidationProvider>

        <ValidationProvider tag="div" name="form_payment_price" rules="required" class="col-md-4">
          <div slot-scope="{ errors }">
            <label for="form_payment_price" class="text-black">Cena za platbu</label>

            <input
              v-model="form.form_payment_price"
              type="number"
              class="form-control"
              :class="{ 'is-invalid': errors[0] }"
              id="form_payment_price"
              name="form_payment_price"
              required
              @keyup="updateMap"
            />
            <span class="invalid-feedback" role="alert">
              <strong>{{ errors[0] }}</strong>
            </span>
          </div>
        </ValidationProvider>
      </div>
    </template>

    <div class="form-group row">
      <div class="col-md-12">
        <label for="message_preview" class="text-black">Zpráva</label>
        <textarea
          v-model="formatedMessage"
          type="text"
          class="form-control"
          name="message_preview"
          rows="13"
          disabled="true"
        ></textarea>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <label for="message_preview" class="text-black">Doplňující sdělení</label>
        <textarea
          v-model="form.payment_request_notes"
          type="text"
          class="form-control"
          name="payment_request_notes"
          rows="4"
          @keyup="updateMap"
        ></textarea>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

// Add the required rule
extend('required', {
  ...required,
  message: 'Toto pole je povinné.'
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    map: {
      type: Object,
      required: true
    },
    order: {
      type: Object,
      required: true
    },
    formDeliveries: {
      type: Array,
      required: true
    },
    formPayments: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      updateTimeout: -1,
      form: {
        price: this.order.price,
        bank_number: this.order.bank_number,
        user_form_delivery_id: this.order.user_form_delivery_id,
        form_delivery_price: this.order.form_delivery_price,
        user_form_payment_id: this.order.user_form_payment_id,
        form_payment_price: this.order.form_payment_price,
        payment_request_notes: this.order.payment_request_notes,
        sync_bank_account: false
      },
      localMap: this.map,
      tab: 'message'
    }
  },
  computed: {
    formatedMessage() {
      let message = this.localMap['MESSAGE'].slice()

      for (let [key, value] of Object.entries(this.localMap)) {
        if (key === 'MUJ_TEXT' || key === 'CISLO_UCTU') continue

        message = message.replace(`%${key}%`, value)
      }

      message = message.replace(`%MUJ_TEXT%`, this.form.payment_request_notes || '')
      message = message.replace(`%CISLO_UCTU%`, this.form.bank_number || '')

      return message
    },
    selectedPayment() {
      return this.formPayments.filter((payment) => {
        return payment.id === this.form.user_form_payment_id
      })[0]
    },
    selectedDelivery() {
      return this.formDeliveries.filter((delivery) => {
        return delivery.id === this.form.user_form_delivery_id
      })[0]
    }
  },
  watch: {
    selectedPayment () {
      this.form.form_payment_price = this.selectedPayment.price
    },
    selectedDelivery () {
      this.form.form_delivery_price = this.selectedDelivery.price
    }
  },
  mounted() {
    this.$refs.observer.validate()
  },
  methods: {
    async updateMap() {
      await this.$nextTick()

      const isValid = await this.$refs.observer.validate()
      if (!isValid) return

      this.localMap.CENA =
        parseFloat(this.form.price) +
        parseFloat(this.form.form_delivery_price) +
        parseFloat(this.form.form_payment_price)

      if (this.order.product.type !== 'service') {
        this.localMap.FORMA_DOPRAVY = this.selectedDelivery.name
        this.localMap.FORMA_UHRADY = this.selectedPayment.name
      }

      clearTimeout(this.updateTimeout)
      this.updateTimeout = setTimeout(() => {
        axios.post(window.orderUpdateURL, this.form)
      }, 500)
    }
  }
}
</script>

<style lang="stylus" scoped>
.form-control:disabled
  background-color: #f3f3f3
</style>
